import React from 'react';
import './PetAnimations.css';

export default function IronGolemSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#A0A0A0';
  const lightColor = color ? lighten(color) : '#C0C0C0';
  const darkColor = color ? darken(color) : '#707070';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Body - blocky */}
      <rect x="38" y="48" width="44" height="36" rx="3" fill={bodyColor} />
      {/* Chest plate line */}
      <rect x="42" y="52" width="36" height="28" rx="2" fill={lightColor} />
      {/* Crack details */}
      <path d="M52 56L54 62L50 68" stroke={darkColor} strokeWidth="1" strokeLinecap="round" fill="none" />
      <path d="M70 54L68 60L72 64" stroke={darkColor} strokeWidth="1" strokeLinecap="round" fill="none" />
      {/* Vine accents */}
      <path d="M42 70C44 68 46 72 48 70C50 68 52 72 54 70" stroke="#4A7A3A" strokeWidth="1.5" strokeLinecap="round" fill="none" />
      <path d="M66 72C68 70 70 74 72 72C74 70 76 74 78 72" stroke="#4A7A3A" strokeWidth="1.5" strokeLinecap="round" fill="none" />
      {/* Left arm */}
      <rect x="22" y="50" width="14" height="32" rx="4" fill={bodyColor} />
      <rect x="24" y="76" width="10" height="10" rx="3" fill={darkColor} />
      {/* Right arm - holding flower */}
      <rect x="84" y="50" width="14" height="32" rx="4" fill={bodyColor} />
      <rect x="86" y="76" width="10" height="10" rx="3" fill={darkColor} />
      {/* Flower in right hand */}
      <line x1="91" y1="76" x2="91" y2="64" stroke="#4A7A3A" strokeWidth="2" strokeLinecap="round" />
      <circle cx="91" cy="62" r="3" fill="#E84040" />
      <circle cx="88" cy="64" r="2.5" fill="#E84040" />
      <circle cx="94" cy="64" r="2.5" fill="#E84040" />
      <circle cx="91" cy="66" r="2.5" fill="#E84040" />
      <circle cx="91" cy="63.5" r="1.5" fill="#FFDD44" />
      {/* Legs */}
      <rect x="40" y="84" width="16" height="20" rx="4" fill={bodyColor} />
      <rect x="64" y="84" width="16" height="20" rx="4" fill={bodyColor} />
      {/* Feet */}
      <rect x="38" y="100" width="20" height="6" rx="3" fill={darkColor} />
      <rect x="62" y="100" width="20" height="6" rx="3" fill={darkColor} />
      {/* Head - blocky */}
      <rect x="40" y="16" width="40" height="34" rx="3" fill={bodyColor} />
      {/* Head top */}
      <rect x="42" y="18" width="36" height="8" rx="2" fill={lightColor} />
      {/* Nose - long golem nose */}
      <rect x="56" y="32" width="8" height="12" rx="2" fill={darkColor} />
      {/* Eyes - glowing */}
      <rect x="46" y="28" width="6" height="4" rx="1" fill="#FF4444" />
      <rect x="68" y="28" width="6" height="4" rx="1" fill="#FF4444" />
      {/* Eye glow */}
      <rect x="47" y="29" width="4" height="2" rx="0.5" fill="#FF8888" />
      <rect x="69" y="29" width="4" height="2" rx="0.5" fill="#FF8888" />
      {/* Eyebrow ridges */}
      <rect x="44" y="26" width="10" height="2" rx="1" fill={darkColor} />
      <rect x="66" y="26" width="10" height="2" rx="1" fill={darkColor} />
      {/* Mouth */}
      <path d="M52 44L60 46L68 44" stroke={darkColor} strokeWidth="1.5" strokeLinecap="round" fill="none" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
